import React, { useState, useEffect } from "react";
import axios from 'axios'
/*import { Link } from "react-router-dom";*/
import { useParams } from "react-router-dom";
import { useUser } from './../components/Context/UserContext';
import { Link, useNavigate } from "react-router-dom";
import { Container, Form, FormGroup, Label, Input } from "reactstrap";
import "../styles/VendorsRegi.css";
import "../styles/forms-redesign.css";
import profileImg from '../assets/logo.png';
import VendorFilesList from '../components/VendorFilesList';
import { Button } from "reactstrap";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import DashboardLayout from "../components/DashboardLayout";
const Vendors = () => {
    const { id } = useParams();
    const { user } = useUser();
    const selectedCompanyId =
        user?.selectedCompany?.id ||
        user?.id ||
        sessionStorage.getItem("userId");
    //const userId = user?.user?.id || sessionStorage.getItem("userId");
    const [successMessage, setSuccessMessage] = useState('');
    const [error, setError] = useState('');
    const [dupErrors, setDupErrors] = useState({ gst: '', account: '', panWarning: '' });
    const [panConfirmed, setPanConfirmed] = useState(false);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [vendorId, setVendorId] = useState(null);
    const [activeTab, setActiveTab] = useState("details");
    const [approvalStatus, setApprovalStatus] = useState(null);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [showCard, setShowCard] = useState(false);
    const [vendorData, setVendorData] = useState(null);
    const navigate = useNavigate();
    const { logoutUser } = useUser();
    const [formDataChecked, setFormDataChecked] = useState({
        hasGST: "yes",   // ✅ default selected
        // other fields...
    });
    const handleLogout = () => {
        logoutUser(); // clears user context/session
        sessionStorage.clear(); // extra safety
        localStorage.clear();   // extra safety
        navigate("/");     // redirect to home
    };
    const [uploadedFiles, setUploadedFiles] = useState({
        panFile: null,
        chequeFile: null,
        gstFile: null,
        msmeFile: null,
    }); 
    const getCurrentLocalDateTime = () => {
        const now = new Date();
        const pad = (n) => n.toString().padStart(2, "0");
        return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
    };
    const [formData, setFormData] = useState({
        natureOfSupply: "",
        businessRegNo: "",
        startDate: "",
        shortName: "",
        legalName: "",
        address1: "",
        address2: "",
        address3: "",
        address4: "",
        city: "",
        state: "",
        country: "",
        postalCode: "",
        telephone: "",
        bankName: "",
        branchName: "",
        ifscCode: "",
        accountNumber: "",
        pan: "",
        hsnsacCode: "",
        beneficiaryName: "",
        gst: "",
        fax: "",
        email: "",
        website: "",
        /*lastMaintained: "",*/
        /*lastMaintained: new Date().toISOString(),*/
        lastMaintained: getCurrentLocalDateTime(),
        msmeno: "",
        enterpriseType: "",  
        hasGST: "no",
        hasMSME: "no",
        hasGST: "no",
        hasMSME: "no",
        vendorCode: "",
        vendorName: "",
        revenue: "",
        investment: "",
        approvalStatus: null,
        // Initialize files as null
        PANCARDIMAGE: null,
        CANCELCHEQUEIMAGE: null,
        GSTIMAGE: null,
        MSMECERTIFICATEIMAGE: null,
    });
    const formatIndianNumber = (num) => {
        if (!num && num !== 0) return "";
        let str = num.toString();
        let lastThree = str.slice(-3);
        let otherNumbers = str.slice(0, -3);
        if (otherNumbers !== "") lastThree = "," + lastThree;
        return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
    };
    const [errors, setErrors] = useState({});
    const [userDetails, setUserDetails] = useState(null);
    const getStatusColor = (status) => {
        if (status === 16) return "green"; // Approved
        if ([15, 10, 6, 3].includes(status)) {
            return "red"; // Rejected
        }
        if (status !== null && status !== undefined) {
            return "orange"; // Pending / In Progress
        }
        return "black"; // Default
    };
    const getStatusBgColor = (status) => {
        if (status === 16) return "#dcfce7"; // light green
        if ([15, 10, 6, 3].includes(status)) return "#fee2e2"; // light red
        if (status !== null && status !== undefined) return "#fef3c7"; // light yellow
        return "#f3f4f6"; // default
    };
    const getApprovalStatusText = (status) => {
        if (status === null || status === undefined) return ""; // Hide when no registration yet
        if (status < 16 && ![15, 10, 6, 3].includes(status)) return "Pending for Approval";
        if (status === 16) return "Registration Approved";
        if ([15, 10, 6, 3].includes(status)) return "Registration Rejected";
        return "";
    };
    const [showPreview, setShowPreview] = useState(false);
    const [previewUrl, setPreviewUrl] = useState("");
    const [previewTitle, setPreviewTitle] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    useEffect(() => {
        const fetchUserDetails = async () => {
            const userId = selectedCompanyId;

            if (!userId) {
                console.log("⏳ Waiting for user to load...");
                return;
            }

            try {
                const { data: userData } = await axios.get(
                    `/api/vendors/userdetails/${userId}`
                );

                console.log("User Data:", userData);

                setFormData(prev => ({
                    ...prev,
                    vendorName: userData?.nameOfCompany || "",
                    vendorEmail: userData?.emailId || "",
                    telephone: userData?.contactNumber || "",
                }));
            } catch (err) {
                console.error("❌ Error fetching user details:", err);
            }
        };

        fetchUserDetails();
    }, [selectedCompanyId]);
    useEffect(() => {
        const dark = localStorage.getItem("darkMode") === "true";
        document.body.classList.toggle("dark-mode", dark);
    }, []);
    const isReadOnlyMode = isSubmitted || (approvalStatus !== null && approvalStatus !== undefined);
    useEffect(() => {
        console.log("User from context:", user);
    }, [user]);
    useEffect(() => {
        const fetchVendorAndUser = async () => {
            const userId = selectedCompanyId;
            if (!userId) {
                console.log("⏳ Waiting for user to load...");
                return;
            }
            console.log("Selected Company ID:", userId);

            console.log("Selected Company:", user?.selectedCompany);
            try {
                // 1️⃣ Fetch user details
                const { data: userData } = await axios.get(
                    `/api/vendors/userdetails/${userId}`
                );
                console.log("User Data:", userData);
                // 2️⃣ Fetch vendorId
                const { data: fetchedVendorId } = await axios.get(
                    `/api/vendors/vendorIdByUser/${userId}`
                );
                console.log("Vendor ID:", fetchedVendorId);
                if (!fetchedVendorId) return;
                setVendorId(fetchedVendorId);
                // 3️⃣ Fetch vendor details
                const { data: vendorData } = await axios.get(
                    `/api/vendors/${fetchedVendorId}`
                );
                console.log("Vendor Data:", vendorData);
                // 4️⃣ Fetch uploaded files
                const { data: uploadedFiles } = await axios.get(
                    `/api/vendor/files/vendor/${fetchedVendorId}`
                );
                console.log("Uploaded Files:", uploadedFiles);
                // 5️⃣ Merge all into formData
                setFormData(prev => ({
                    ...prev,
                    ...vendorData,
                    vendorName: userData?.nameOfCompany || "",
                    vendorEmail: userData?.emailId || "",
                    natureOfSupply: vendorData.natureOfSupply || "",
                    businessRegNo: vendorData.businessRegNo || "",
                    startDate: vendorData.startDate ? vendorData.startDate.split("T")[0] : "",
                    shortName: vendorData.shortName || "",
                    legalName: vendorData.legalName || "",
                    address1: vendorData.address1 || "",
                    address2: vendorData.address2 || "",
                    address3: vendorData.address3 || "",
                    address4: vendorData.address4 || "",
                    city: vendorData.city || "",
                    state: vendorData.state || "",
                    country: vendorData.country || "",
                    postalCode: vendorData.postalCode?.toString() || "",
                    telephone: vendorData.telephone || "",
                    fax: vendorData.fax || "",
                    email: vendorData.email || userData?.emailId || "",
                    website: vendorData.website || "",
                    msmeno: vendorData.msmeno || "",
                    enterpriseType: vendorData.enterpriseType || "", 
                    pan: vendorData.pan || "",
                    gst: vendorData.gst || "",
                    beneficiaryName: vendorData.beneficiaryName || "",
                    bankName: vendorData.bankName || "",
                    branchName: vendorData.branchName || "",
                    ifscCode: vendorData.ifscCode || "",
                    accountNumber: vendorData.accountNumber || "",
                    hsnsacCode: vendorData.hsnsacCode || "",
                    //lastMaintained: vendorData.lastMaintained
                    //    ? vendorData.lastMaintained.split("T")[0]
                    //    : "",
                    lastMaintained: vendorData.lastMaintained || "",
                    hasGST: vendorData.gst ? "yes" : "no",
                    hasMSME: vendorData.msmeno ? "yes" : "no",
                    vendorCode: vendorData.vendorcode || "",
                    revenue: vendorData.revenue || "",
                    investment: vendorData.investment || "",
                    approvalStatus: vendorData.approvalStatus || null,
                    // ✅ now it's safe to use uploadedFiles
                    PANCARDIMAGE: uploadedFiles.find(f => f.docName === "PAN") || null,
                    CANCELCHEQUEIMAGE: uploadedFiles.find(f => f.docName === "CHEQUE") || null,
                    GSTIMAGE: uploadedFiles.find(f => f.docName === "GST") || null,
                    MSMECERTIFICATEIMAGE: uploadedFiles.find(f => f.docName === "MSME") || null
                }));
                if (vendorData.approvalStatus !== null) {
                    setApprovalStatus(vendorData.approvalStatus);
                    setIsSubmitted(true); // disables submit button automatically
                }
            } catch (err) {
                console.error("❌ Error fetching user/vendor data:", err);
            }
        };
        fetchVendorAndUser();
    }, [user]);
    const handleInputChange = (e) => {
        const { id, value } = e.target;
        if (id === "revenue" || id === "investment") {
            // Remove commas before saving
            const raw = value.replace(/,/g, "");
            // Accept only numbers
            if (/^\d*\.?\d*$/.test(raw)) {
                setFormData(prevData => ({
                    ...prevData,
                    [id]: raw,
                }));
            }
        } else {
            setFormData(prevData => ({
                ...prevData,
                [id]: value,
            }));
        }
        if (errors[id]) {
            setErrors(prevErrors => ({ ...prevErrors, [id]: "" }));
        }
    };
    const handleFileChange = (e) => {
        const { name, files } = e.target;
        if (files && files.length > 0) {
            const file = files[0];
            setFormData((prevData) => ({
                ...prevData,
                [name]: { file, fileName: file.name },  // ✅ store file object + name
            }));
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: "",
            }));
        }
    };
    const checkGstDuplicate = async (gstValue) => {
        if (!gstValue?.trim()) return;
        try {
            const excludeParam = vendorId ? `?excludeVendorId=${vendorId}` : '';
            const res = await axios.get(`/api/vendors/check-gst/${gstValue.trim()}${excludeParam}`);
            setDupErrors(prev => ({
                ...prev,
                gst: res.data.exists ? `This GST number is already registered to another vendor.` : ''
            }));
        } catch (err) {
            console.error('GST check failed:', err);
        }
    };

    const checkAccountDuplicate = async (accNo, ifsc) => {
        if (!accNo?.trim() || !ifsc?.trim()) return;
        try {
            const excludeParam = vendorId ? `?excludeVendorId=${vendorId}` : '';
            const res = await axios.get(`/api/vendors/check-account/${accNo.trim()}/${ifsc.trim()}${excludeParam}`);
            setDupErrors(prev => ({
                ...prev,
                account: res.data.exists ? `This bank account and IFSC combination is already linked to another vendor.` : ''
            }));
        } catch (err) {
            console.error('Account check failed:', err);
        }
    };

    const checkPanDuplicate = async (panValue) => {
        if (!panValue?.trim()) return;
        try {
            const excludeParam = vendorId ? `?excludeVendorId=${vendorId}` : '';
            const res = await axios.get(`/api/vendors/check-pan/${panValue.trim()}${excludeParam}`);
            if (res.data.exists) {
                const names = res.data.vendorNames?.filter(Boolean); // remove empty/undefined entries
                const namesText = names && names.length > 0 ? ` (linked to: ${names.join(', ')})` : '';
                setDupErrors(prev => ({
                    ...prev,
                    panWarning: `This PAN is already registered under another vendor${namesText}. If this is a different GST registration under the same PAN, confirm below.`
                }));
            } else {
                setDupErrors(prev => ({ ...prev, panWarning: '' }));
                setPanConfirmed(false);
            }
        } catch (err) {
            console.error('PAN check failed:', err);
        }
    };
    const validateForm = () => {
        let newErrors = {};
        // --- Required fields with custom messages ---
        if (!formData.natureOfSupply) newErrors.natureOfSupply = "Please select a Nature of supply";
        if (!formData.legalName) newErrors.legalName = "Enter Legal Name";
        if (!formData.startDate) newErrors.startDate = "Date is required";
        if (!formData.shortName) newErrors.shortName = "Enter Short Name";
        if (!formData.address1) newErrors.address1 = "Please enter Address Line 1";
        if (!formData.city) newErrors.city = "City is required";
        if (!formData.state) newErrors.state = "State is required";
        if (!formData.country) newErrors.country = "Country is required";
        if (!formData.postalCode) newErrors.postalCode = "Enter PIN code";
        else if (!/^\d{6}$/.test(formData.postalCode)) newErrors.postalCode = "Zip/Postal Code must be 6 digits";
        if (!formData.bankName) newErrors.bankName = "Bank Name is required";
        if (!formData.branchName) newErrors.branchName = "Branch is required";
        if (!formData.ifscCode) newErrors.ifscCode = "IFSC is required";
        if (!formData.accountNumber) newErrors.accountNumber = "Enter Account Number";
        else if (!/^\d+$/.test(formData.accountNumber)) newErrors.accountNumber = "Account Number must be numeric";
        if (!formData.beneficiaryName) newErrors.beneficiaryName = "Enter Beneficiary Name";
        // --- PAN & HSN/SAC ---
        if (!formData.pan) newErrors.pan = "PAN is required";
        else if (!/^[A-Z]{5}\d{4}[A-Z]$/.test(formData.pan)) newErrors.pan = "PAN format invalid";
        if (!formData.hsnsacCode) newErrors.hsnsacCode = "HSN/SAC is required";
        // Optional numeric fields
        if (!formData.revenue) {
            newErrors.revenue = "Revenue is required";
        } else if (isNaN(formData.revenue.replace(/,/g, ''))) {
            // Remove commas if using Indian number formatting
            newErrors.revenue = "Revenue must be a number";
        }
        // Investment validation
        if (!formData.investment) {
            newErrors.investment = "Investment is required";
        } else if (isNaN(formData.investment.replace(/,/g, ''))) {
            newErrors.investment = "Investment must be a number";
        }
        if (!formData.PANCARDIMAGE) newErrors.PANCARDIMAGE = "upload PAN Card";
        if (!formData.CANCELCHEQUEIMAGE) newErrors.CANCELCHEQUEIMAGE = "upload Cancel Cheque";
        // --- GST Validation ---
        if (formData.hasGST === "yes") {
            if (!formData.gst?.trim()) newErrors.gst = "Enter GST Number";
            if (!formData.GSTIMAGE?.file && !formData.GSTIMAGE?.fileId)
                newErrors.GSTIMAGE = "Upload GST Certificate";
        }
        if (formData.hasMSME === "yes") {
            if (!formData.msmeno?.trim()) newErrors.msmeno = "Enter MSME Number";
            if (!formData.MSMECERTIFICATEIMAGE?.file && !formData.MSMECERTIFICATEIMAGE?.fileId)
                newErrors.MSMECERTIFICATEIMAGE = "Upload MSME Certificate";
            if (!formData.enterpriseType)
                newErrors.enterpriseType = "Please select Type of Enterprise";
        }
        // --- Duplicate checks ---
        if (dupErrors.gst) newErrors.gst = dupErrors.gst;
        if (dupErrors.account) newErrors.accountNumber = dupErrors.account;
        if (dupErrors.panWarning && !panConfirmed) {
            newErrors.pan = "Please confirm the PAN warning before submitting.";
        }
        setErrors(newErrors);
        return { isValid: Object.keys(newErrors).length === 0, errors: newErrors };
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        const userId = user?.id || sessionStorage.getItem("userId");
        if (!userId) {
            console.error("User ID missing.");
            setError("User ID missing. Please login again.");
            return;
        }
        const validation = validateForm();
        if (!validation.isValid) {
            console.warn("Validation failed — stopping submission");
            
            // If there's an error on the details tab, switch to it so the user can see it
            const detailsFields = ["natureOfSupply", "legalName", "startDate", "shortName", "address1", "city", "state", "country", "postalCode"];
            const hasDetailsError = detailsFields.some(field => validation.errors[field]);
            
            if (hasDetailsError && activeTab !== "details") {
                setActiveTab("details");
            }
            return;
        }
        try {
            const formDataToSend = new FormData();
            Object.entries(formData).forEach(([key, value]) => {
                if (value !== undefined && value !== null) {
                    // ✅ Handle file objects properly
                    if (value instanceof File) {
                        formDataToSend.append(key, value);
                    } else if (value.file instanceof File) {
                        formDataToSend.append(key, value.file);
                    } else {
                        formDataToSend.append(key, value.toString());
                    }
                }
            });
            // Append USERID
            formDataToSend.append("USERID", userId);
            // Debug log
            for (let pair of formDataToSend.entries()) {
                console.log(pair[0], pair[1]);
            }
            const response = await axios.post(
                "/api/vendors",
                formDataToSend,
                {
                    headers: { "Content-Type": "multipart/form-data" },
                }
            );
            console.log("Response:", response.data);
            if (response.status === 200 || response.status === 201) {
                setIsSubmitted(true);
                setVendorId(response.data.vendorId);
                /*setSuccessMessage(`Vendor successfully registered! Vendor ID: ${response.data.vendorId}`);*/
                setSuccessMessage(`Vendor successfully registered!`);
                setError("");
            } else {
                setError("Vendor registration failed. Please try again.");
            }
        } catch (err) {
            console.error("Axios error:", err.response?.data || err);
            setError(err.response?.data?.message || "There was an error with vendor registration.");
        }
    };
    return (
        <DashboardLayout>
            <div className="vendors-container">
                <div className="main-layout">
                    <div className="vendor-content">
                        <div className="invoice-header">
                            <h2 className="invoice-title">Vendor Registration</h2>
                        </div>                      
                        <div
                            className="vendor-container"
                            style={{
                                marginBottom: "0px"
                            }}
                        >
                            <div
                                className="vendor-box"
                                style={{
                                    padding: "12px 16px",
                                    border: "1px solid #dee2e6",
                                    borderRadius: "8px",
                                    background: "#fff"
                                }}
                            >
                                <div
                                    className="vendor-inline"
                                    style={{
                                        display: "flex",
                                        gap: "20px",
                                        alignItems: "flex-start"
                                    }}
                                >
                                    <FormGroup
                                        className="inline-group"
                                        style={{
                                            flex: 1,
                                            marginBottom: "0"
                                        }}
                                    >
                                        <Label
                                            for="vendorName"
                                            style={{
                                                marginBottom: "4px",
                                                fontWeight: "600",
                                                fontSize: "14px"
                                            }}
                                        >
                                            Vendor Name <span className="required-field">*</span>
                                        </Label>

                                        <Input
                                            type="text"
                                            id="vendorName"
                                            value={formData?.vendorName || ""}
                                            placeholder="N/A"
                                            readOnly
                                            className="color-input"
                                            style={{
                                                height: "36px",
                                                fontSize: "14px",
                                                padding: "6px 10px"
                                            }}
                                        />
                                    </FormGroup>

                                    <FormGroup
                                        className="inline-group"
                                        style={{
                                            flex: 1,
                                            marginBottom: "0"
                                        }}
                                    >
                                        <Label
                                            for="vendorCode"
                                            style={{
                                                marginBottom: "4px",
                                                fontWeight: "600",
                                                fontSize: "14px"
                                            }}
                                        >
                                            Vendor Code
                                        </Label>

                                        <Input
                                            type="text"
                                            id="vendorCode"
                                            value={formData?.vendorCode || ""}
                                            placeholder="N/A"
                                            readOnly
                                            className="color-input"
                                            style={{
                                                height: "36px",
                                                fontSize: "14px",
                                                padding: "6px 10px"
                                            }}
                                        />
                                    </FormGroup>
                                </div>
                            </div>
                        </div>
                        <div className="status-header">
                            {(formData?.approvalStatus !== null && formData?.approvalStatus !== undefined) && (
                                <div className="status-container">
                                    <span className="status-label">Registration Status:</span>
                                    <span
                                        className="status-badge"
                                        style={{
                                            color: getStatusColor(formData.approvalStatus),
                                            borderColor: getStatusColor(formData.approvalStatus),
                                            backgroundColor: getStatusBgColor(formData.approvalStatus)
                                        }}
                                    >
                                        {getApprovalStatusText(formData.approvalStatus)}
                                    </span>
                                </div>
                            )}
                        </div>
                        <div>
                            <Form onSubmit={(e) => e.preventDefault()}>
                                {/* ==================== DETAILS TAB ==================== */}
                                {activeTab === "details" && (
                                    <div className="details-grid">
                                        <FormGroup className="form-group">
                                            <Label for="natureOfSupply">Nature of Supply</Label>
                                            <Input type="select" id="natureOfSupply" className="form-input"
                                                value={formData.natureOfSupply}
                                                onChange={handleInputChange}
                                                disabled={isReadOnlyMode}>
                                                <option value="">{isReadOnlyMode ? "N/A" : "Select"}</option>
                                                <option value="Goods">Goods</option>
                                                <option value="Services">Services</option>
                                                <option value="Both">Both</option>
                                            </Input>
                                            
                                            {errors.natureOfSupply && <span className="error-text">{errors.natureOfSupply}</span>}
                                        </FormGroup>
                                        <FormGroup className="form-group">
                                            <Label for="businessRegNo">Business Reg No. <span className="required-field">*</span></Label>
                                            <Input type="text" id="businessRegNo" className="form-input"
                                                value={formData.businessRegNo}
                                                placeholder={isReadOnlyMode ? "N/A" : "Enter Business Reg No."}
                                                onChange={handleInputChange}
                                                disabled={isReadOnlyMode} />
                                        </FormGroup>
                                        <FormGroup className="form-group">
                                            <Label for="startDate">Start Date</Label>
                                            <Input type="date" id="startDate" className="form-input"
                                                value={formData.startDate}
                                                onChange={handleInputChange}
                                                disabled={isReadOnlyMode} />
                                            
                                            {errors.startDate && <span className="error-text">{errors.startDate}</span>}
                                        </FormGroup>
                                        <FormGroup className="form-group">
                                            <Label for="legalName">Legal Name <span className="required-field">*</span></Label>
                                            <Input type="text" id="legalName" className="form-input"
                                                value={formData.legalName}
                                                placeholder={isReadOnlyMode ? "N/A" : "Enter Legal Name"}
                                                onChange={handleInputChange}
                                                disabled={isReadOnlyMode} />
                                            
                                            {errors.legalName && <span className="error-text">{errors.legalName}</span>}
                                        </FormGroup>
                                        <FormGroup className="form-group">
                                            <Label for="shortName">Short Name <span className="required-field">*</span></Label>
                                            <Input type="text" id="shortName" className="form-input"
                                                value={formData.shortName}
                                                placeholder={isReadOnlyMode ? "N/A" : "Enter Short Name"}
                                                onChange={handleInputChange}
                                                disabled={isReadOnlyMode} />
                                            
                                            {errors.shortName && <span className="error-text">{errors.shortName}</span>}
                                        </FormGroup>
                                        <FormGroup className="form-group">
                                            <Label for="address1">Address Line 1 <span className="required-field">*</span></Label>
                                            <Input type="text" id="address1" className="form-input"
                                                value={formData.address1}
                                                placeholder={isReadOnlyMode ? "N/A" : "Enter Address Line 1"}
                                                onChange={handleInputChange}
                                                disabled={isReadOnlyMode} />
                                            
                                            {errors.address1 && <span className="error-text">{errors.address1}</span>}
                                        </FormGroup>
                                        <FormGroup className="form-group">
                                            <Label for="address2">Address Line 2 <span className="required-field">*</span></Label>
                                            <Input type="text" id="address2" className="form-input"
                                                value={formData.address2}
                                                placeholder={isReadOnlyMode ? "N/A" : "Enter Address Line 2"}
                                                onChange={handleInputChange}
                                                disabled={isReadOnlyMode} />
                                            {errors.address2 && <span className="error-text">{errors.address2}</span>}
                                        </FormGroup>
                                        <FormGroup className="form-group">
                                            <Label for="address3">Address Line 3</Label>
                                            <Input type="text" id="address3" className="form-input"
                                                value={formData.address3}
                                                placeholder={isReadOnlyMode ? "N/A" : "Enter Address Line 3"}
                                                onChange={handleInputChange}
                                                disabled={isReadOnlyMode} />
                                            {errors.address3 && <span className="error-text">{errors.address3}</span>}
                                        </FormGroup>
                                        <FormGroup className="form-group">
                                            <Label for="address4">Address Line 4</Label>
                                            <Input type="text" id="address4" className="form-input"
                                                value={formData.address4}
                                                placeholder={isReadOnlyMode ? "N/A" : "Enter Address Line 4"}
                                                onChange={handleInputChange}
                                                disabled={isReadOnlyMode} />
                                            {errors.address4 && <span className="error-text">{errors.address4}</span>}
                                        </FormGroup>
                                        <FormGroup className="form-group">
                                            <Label for="city">City</Label>
                                            <Input type="text" id="city" className="form-input"
                                                value={formData.city}
                                                placeholder={isReadOnlyMode ? "N/A" : "Enter City"}
                                                onChange={handleInputChange}
                                                disabled={isReadOnlyMode} />
                                            
                                            {errors.city && <span className="error-text">{errors.city}</span>}
                                        </FormGroup>
                                        <FormGroup className="form-group">
                                            <Label for="state">State <span className="required-field">*</span></Label>
                                            <Input type="text" id="state" className="form-input"
                                                value={formData.state}
                                                placeholder={isReadOnlyMode ? "N/A" : "Enter State"}
                                                onChange={handleInputChange}
                                                disabled={isReadOnlyMode} />
                                            
                                            {errors.state && <span className="error-text">{errors.state}</span>}
                                        </FormGroup>
                                        <FormGroup className="form-group">
                                            <Label for="country">Country <span className="required-field">*</span></Label>
                                            <Input type="text" id="country" className="form-input"
                                                value={formData.country}
                                                placeholder={isReadOnlyMode ? "N/A" : "Enter Country"}
                                                onChange={handleInputChange}
                                                disabled={isReadOnlyMode} />
                                            
                                            {errors.country && <span className="error-text">{errors.country}</span>}
                                        </FormGroup>
                                        <FormGroup className="form-group">
                                            <Label for="postalCode">Zip/Postal Code <span className="required-field">*</span></Label>
                                            <Input type="text" id="postalCode" className="form-input"
                                                value={formData.postalCode}
                                                placeholder={isReadOnlyMode ? "N/A" : "Enter Zip/Postal Code"}
                                                onChange={handleInputChange}
                                                maxLength={6}
                                                disabled={isReadOnlyMode} />
                                            
                                            {errors.postalCode && <span className="error-text">{errors.postalCode}</span>}
                                        </FormGroup>
                                        <FormGroup className="form-group">
                                            <Label for="telephone">Telephone <span className="required-field">*</span></Label>
                                            <Input type="text" id="telephone" className="form-input"
                                                value={formData.telephone}
                                                placeholder={isReadOnlyMode ? "N/A" : "Enter Telephone"}
                                                onChange={handleInputChange}
                                                maxLength={10}
                                                disabled={isReadOnlyMode} />
                                            
                                            {errors.telephone && <div className="error-text">{errors.telephone}</div>}
                                        </FormGroup>
                                        <FormGroup className="form-group">
                                            <Label for="fax">Fax <span className="required-field">*</span></Label>
                                            <Input type="text" id="fax" className="form-input"
                                                value={formData.fax}
                                                placeholder={isReadOnlyMode ? "N/A" : "Enter Fax"}
                                                onChange={handleInputChange}
                                                disabled={isReadOnlyMode} />
                                        </FormGroup>
                                        <FormGroup className="form-group">
                                            <Label for="email">E-Mail</Label>
                                            <Input type="text" id="email" className="form-input"
                                                value={formData.email || ""}
                                                placeholder={isReadOnlyMode ? "N/A" : "Enter E-Mail"}
                                                onChange={handleInputChange}
                                                disabled={isReadOnlyMode} />
                                        </FormGroup>
                                        <FormGroup className="form-group">
                                            <Label for="website">Website</Label>
                                            <Input type="text" id="website" className="form-input"
                                                value={formData.website}
                                                placeholder={isReadOnlyMode ? "N/A" : "Enter Website URL"}
                                                onChange={handleInputChange}
                                                disabled={isReadOnlyMode} />
                                        </FormGroup>
                                        <FormGroup className="form-group">
                                            <Label for="lastMaintained">Last Maintained</Label>
                                            <Input type="text" id="lastMaintained" className="form-input"
                                                value={formData.lastMaintained ? new Date(formData.lastMaintained.replace(" ", "T"))
                                                    .toLocaleString("en-US", {
                                                        month: "numeric",
                                                        day: "numeric",
                                                        year: "numeric",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        second: "2-digit",
                                                        hour12: true,
                                                        timeZone: "Asia/Kolkata"
                                                    }).replace(",", "") : ""}
                                                placeholder="N/A"
                                                readOnly disabled />
                                        </FormGroup>
                                        <div className="next-btn-container">
                                            <Button type="button" className="next-btn"
                                                onClick={() => setActiveTab("other")}>
                                                Next →
                                            </Button>
                                        </div>
                                    </div>
                                )}
                                {/* ==================== OTHER TAB ==================== */}
                                {activeTab === "other" && (
                                    <div className="details-grid">
                                        <FormGroup className="compact-field">
                                            <Label for="bankName">Bank Name</Label>
                                            <Input
                                                type="text"
                                                id="bankName"
                                                value={formData.bankName}
                                                placeholder={isReadOnlyMode ? "N/A" : "Enter Bank Name"}
                                                onChange={handleInputChange}
                                                disabled={isReadOnlyMode}
                                            />
                                            
                                            {errors.bankName && <span className="error-text">{errors.bankName}</span>}
                                        </FormGroup>
                                        <FormGroup className="compact-field">
                                            <Label for="branchName">Branch Name <span className="required-field">*</span></Label>
                                            <Input
                                                type="text"
                                                id="branchName"
                                                value={formData.branchName}
                                                placeholder={isReadOnlyMode ? "N/A" : "Enter Branch Name"}
                                                onChange={handleInputChange}
                                                disabled={isReadOnlyMode}
                                            />
                                            
                                            {errors.branchName && <span className="error-text">{errors.branchName}</span>}
                                        </FormGroup>
                                        <FormGroup className="compact-field">
                                            <Label for="ifscCode">IFSC Code <span className="required-field">*</span></Label>
                                            <Input
                                                type="text"
                                                id="ifscCode"
                                                value={formData.ifscCode}
                                                placeholder={isReadOnlyMode ? "N/A" : "Enter IFSC Code"}
                                                onChange={handleInputChange}
                                                onBlur={() => checkAccountDuplicate(formData.accountNumber, formData.ifscCode)}
                                                disabled={isReadOnlyMode}
                                            />
                                        </FormGroup>
                                        <FormGroup className="compact-field">
                                            <Label for="accountNumber">Account Number <span className="required-field">*</span></Label>
                                            <Input
                                                type="text"
                                                id="accountNumber"
                                                value={formData.accountNumber}
                                                placeholder={isReadOnlyMode ? "N/A" : "Enter Account Number"}
                                                onChange={handleInputChange}
                                                onBlur={() => checkAccountDuplicate(formData.accountNumber, formData.ifscCode)}
                                                disabled={isReadOnlyMode}
                                            />

                                            {errors.accountNumber && <span className="error-text">{errors.accountNumber}</span>}
                                            {dupErrors.account && <span className="error-text">{dupErrors.account}</span>}
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="pan">PAN <span className="required-field">*</span></Label>
                                            <div className="input-error-container">
                                                <Input type="text" id="pan" value={formData.pan} placeholder={isReadOnlyMode ? "N/A" : "Enter PAN"} onChange={handleInputChange} onBlur={() => checkPanDuplicate(formData.pan)} disabled={isReadOnlyMode} />

                                                {errors.pan && <span className="error-text">{errors.pan}</span>}
                                                {dupErrors.panWarning && (
                                                    <div style={{ color: '#b45309', fontSize: '13px', marginTop: '4px' }}>
                                                        {dupErrors.panWarning}
                                                        <div>
                                                            <label>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={panConfirmed}
                                                                    onChange={(e) => setPanConfirmed(e.target.checked)}
                                                                /> Confirm this is a valid separate registration
                                                            </label>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </FormGroup>
                                        <FormGroup>
                                            <div
                                                className="file-upload-row"
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "8px",
                                                    flexWrap: "wrap",
                                                    margin: 0,
                                                    padding: 0,
                                                }}
                                            >
                                                <Label for="PANCARDIMAGE" >Upload PAN Card: <span className="required-field">*</span></Label>
                                                <Input
                                                    type="file"
                                                    name="PANCARDIMAGE"
                                                    onChange={handleFileChange}
                                                    disabled={isReadOnlyMode}
                                                />
                                                
                                                {formData.PANCARDIMAGE?.fileName && (
                                                    <span className="file-upload-name" title={formData.PANCARDIMAGE.fileName}>
                                                        {(formData.PANCARDIMAGE?.name || formData.PANCARDIMAGE?.fileName).slice(0, 15)}
                                                    </span>
                                                )}
                                                {errors.PANCARDIMAGE && (
                                                    <span className="error-text">{errors.PANCARDIMAGE}</span>
                                                )}
                                            </div>
                                            {(formData.PANCARDIMAGE?.fileId || formData.PANCARDIMAGE?.file) && (
                                                <div
                                                    className="file-upload-actions"
                                                    style={{
                                                        display: "flex",
                                                        gap: "8px",
                                                        marginTop: "8px",
                                                        justifyContent: "center", // center the buttons horizontally
                                                        width: "100%",
                                                    }}
                                                >
                                                    <Button
                                                        color="primary"
                                                        className="custom-btn view-btn"
                                                        size="sm"
                                                        outline
                                                        onClick={() => {
                                                            const url = formData.PANCARDIMAGE?.fileId
                                                                ? `/api/vendor/files/${formData.PANCARDIMAGE.fileId}?mode=view`
                                                                : URL.createObjectURL(formData.PANCARDIMAGE.file);
                                                            setPreviewUrl(url);
                                                            setPreviewTitle("PAN Card Preview");
                                                            setSelectedFile(formData.PANCARDIMAGE);
                                                            setShowPreview(true);
                                                        }}
                                                    >
                                                        View
                                                    </Button>
                                                    <a
                                                        href={
                                                            formData.PANCARDIMAGE?.fileId
                                                                ? `/api/vendor/files/${formData.PANCARDIMAGE.fileId}`
                                                                : URL.createObjectURL(formData.PANCARDIMAGE.file)
                                                        }
                                                        download={formData.PANCARDIMAGE.fileName}
                                                        className="custom-btn download-btn"
                                                        style={{ display: "none" }}
                                                    >
                                                        Download
                                                    </a>
                                                </div>
                                            )}
                                        </FormGroup>
                                        {/* Single shared Preview Modal */}
                                        <Modal isOpen={showPreview} toggle={() => setShowPreview(false)} size="lg" centered className="file-preview-modal">
                                            <ModalHeader toggle={() => setShowPreview(false)}>{previewTitle}</ModalHeader>
                                            <ModalBody style={{ textAlign: "center", padding: "0" }}>
                                                {selectedFile?.fileName?.toLowerCase().endsWith(".pdf") ? (
                                                    <iframe src={previewUrl} style={{ width: "100%", height: "80vh", border: "none", display: "block" }} title="PDF Preview" />
                                                ) : (
                                                    <img src={previewUrl} style={{ maxWidth: "100%", maxHeight: "80vh", display: "block", margin: "0 auto" }} alt="preview" />
                                                )}
                                            </ModalBody>
                                        </Modal>
                                        <FormGroup>
                                            <Label for="hsnsacCode">HSN/SAC Code <span className="required-field">*</span></Label>
                                            <div className="input-error-container">
                                                <Input type="text" id="hsnsacCode" value={formData.hsnsacCode} placeholder={isReadOnlyMode ? "N/A" : "Enter HSN/SAC Code"} onChange={handleInputChange} disabled={isReadOnlyMode} />
                                                
                                                {errors.hsnsacCode && <span className="error-text">{errors.hsnsacCode}</span>}
                                            </div>
                                        </FormGroup>
                                        <FormGroup
                                            className="file-upload-wrapper"
                                            style={{ display: "flex", flexDirection: "column", gap: "4px" }}
                                        >
                                            <div
                                                className="file-upload-row"
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "8px",
                                                    flexWrap: "wrap",
                                                    margin: 0,
                                                    padding: 0,
                                                }}
                                            >
                                                <Label for="CANCELCHEQUEIMAGE" className="file-upload-label">
                                                    Upload Cancelled Cheque:
                                                 <span className="required-field">*</span></Label>
                                                <Input
                                                    type="file"
                                                    name="CANCELCHEQUEIMAGE"
                                                    onChange={handleFileChange}
                                                    disabled={isReadOnlyMode}
                                                />
                                                
                                                {(formData.CANCELCHEQUEIMAGE?.file?.name || formData.CANCELCHEQUEIMAGE?.fileName) && (
                                                    <span
                                                        className="file-upload-name"
                                                        title={formData.CANCELCHEQUEIMAGE?.file?.name || formData.CANCELCHEQUEIMAGE?.fileName}
                                                    >
                                                        {(formData.CANCELCHEQUEIMAGE?.file?.name || formData.CANCELCHEQUEIMAGE?.fileName).slice(0, 15)}
                                                    </span>
                                                )}
                                                {errors.CANCELCHEQUEIMAGE && (
                                                    <span className="error-text">{errors.CANCELCHEQUEIMAGE}</span>
                                                )}
                                            </div>
                                            {/* Row 2: View + Download buttons centered below the input */}
                                            {(formData.CANCELCHEQUEIMAGE?.fileId || formData.CANCELCHEQUEIMAGE?.file) && (
                                                <div
                                                    className="file-upload-actions"
                                                    style={{
                                                        display: "flex",
                                                        gap: "8px",
                                                        marginTop: "8px",
                                                        justifyContent: "center", // centers buttons below the input
                                                        width: "100%",            // full width container
                                                    }}
                                                >
                                                    <Button
                                                        color="primary"
                                                        size="sm"
                                                        className="custom-btn view-btn"
                                                        outline
                                                        onClick={() => {
                                                            const url = formData.CANCELCHEQUEIMAGE?.fileId
                                                                ? `/api/vendor/files/${formData.CANCELCHEQUEIMAGE.fileId}?mode=view`
                                                                : URL.createObjectURL(formData.CANCELCHEQUEIMAGE.file);
                                                            setPreviewUrl(url);
                                                            setPreviewTitle("Cancelled Cheque Preview");
                                                            setSelectedFile(formData.CANCELCHEQUEIMAGE);
                                                            setShowPreview(true);
                                                        }}
                                                    >
                                                        View
                                                    </Button>
                                                    <a
                                                        href={
                                                            formData.CANCELCHEQUEIMAGE?.fileId
                                                                ? `/api/vendor/files/${formData.CANCELCHEQUEIMAGE.fileId}`
                                                                : URL.createObjectURL(formData.CANCELCHEQUEIMAGE.file)
                                                        }
                                                        download={formData.CANCELCHEQUEIMAGE.fileName}
                                                        className="custom-btn download-btn" style={{ display: "none" }}
                                                    >
                                                        Download
                                                    </a>
                                                </div>
                                            )}
                                        </FormGroup>
                                        {/* GST Yes/No */}
                                        <FormGroup className="msme-container mt-4">
                                            <Label className="msme-label">Do you have GST? <span className="required-field">*</span></Label>
                                            <div className="toggle-group mt-2">
                                                <Label className={formData.hasGST === "yes" ? "toggle-label active" : "toggle-label"}>
                                                    <Input
                                                        type="radio"
                                                        name="hasGST"
                                                        value="yes"                                                        
                                                        checked={formData.hasGST === "yes"}
                                                        disabled={isReadOnlyMode}
                                                        onChange={(e) =>
                                                            setFormData({ ...formData, hasGST: e.target.value })
                                                        }
                                                    />
                                                    Yes
                                                </Label>
                                                <Label className={formData.hasGST === "no" ? "toggle-label active" : "toggle-label"}>
                                                    <Input
                                                        type="radio"
                                                        name="hasGST"
                                                        value="no"
                                                        checked={formData.hasGST === "no"}
                                                        disabled={isReadOnlyMode}
                                                        onChange={(e) => {
                                                            setFormData({
                                                                ...formData,
                                                                hasGST: e.target.value,
                                                                gst: "",
                                                                GSTIMAGE: null,
                                                            });
                                                            setDupErrors(prev => ({ ...prev, gst: '' }));
                                                        }}
                                                    />
                                                    No
                                                </Label>
                                            </div>
                                        </FormGroup>
                                        {formData.hasGST === "yes" && (
                                            <div className="expandable-section">
                                                <FormGroup>
                                                    <Label for="gst">GST Number</Label>
                                                    <Input
                                                        type="text"
                                                        id="gst"
                                                        name="gst"
                                                        value={formData.gst || ""}
                                                        placeholder={isReadOnlyMode ? "N/A" : "Enter GST Number"}
                                                        onChange={handleInputChange}
                                                        onBlur={() => checkGstDuplicate(formData.gst)}
                                                        disabled={isReadOnlyMode}
                                                    />

                                                    {errors.gst && <span className="error-text">{errors.gst}</span>}
                                                    {dupErrors.gst && <span className="error-text">{dupErrors.gst}</span>}
                                                </FormGroup>
                                                {/* GST Upload */}
                                                <FormGroup className="form-group">
                                                    <Label for="GSTIMAGE">Upload GST Certificate: <span className="required-field">*</span></Label>
                                                    <Input type="file" name="GSTIMAGE" onChange={handleFileChange} disabled={isReadOnlyMode} />
                                                    
                                                    {formData.GSTIMAGE?.fileName && (
                                                        <span title={formData.GSTIMAGE.fileName} style={{ display: "block", marginTop: "4px", fontSize: "12px", color: "var(--fld-text)" }}>
                                                            {formData.GSTIMAGE.fileName.slice(0, 20)}
                                                        </span>
                                                    )}
                                                    {errors.GSTIMAGE && (
                                                        <span className="error-text">
                                                            {errors.GSTIMAGE}
                                                        </span>
                                                    )}
                                                    {(formData.GSTIMAGE?.fileId || formData.GSTIMAGE?.file) && (
                                                        <div style={{ marginTop: "8px", display: "flex", gap: "8px", alignItems: "center" }}>
                                                            <Button
                                                                color="primary"
                                                                size="sm"
                                                                className="custom-btn view-btn"
                                                                outline
                                                                onClick={() => {
                                                                    const url = formData.GSTIMAGE?.fileId
                                                                        ? `/api/vendor/files/${formData.GSTIMAGE.fileId}?mode=view`
                                                                        : URL.createObjectURL(formData.GSTIMAGE.file);
                                                                    setPreviewUrl(url);
                                                                    setPreviewTitle("GST Certificate Preview");
                                                                    setSelectedFile(formData.GSTIMAGE);
                                                                    setShowPreview(true);
                                                                }}
                                                            >
                                                                View
                                                            </Button>
                                                            <a
                                                                href={
                                                                    formData.GSTIMAGE?.fileId
                                                                        ? `/api/vendor/files/${formData.GSTIMAGE.fileId}`
                                                                        : URL.createObjectURL(formData.GSTIMAGE.file)
                                                                }
                                                                download={formData.GSTIMAGE.fileName}
                                                                className="custom-btn download-btn"
                                                                style={{ display: "none" }}
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    )}
                                                </FormGroup>
                                            </div>
                                        )}
                                        {/* MSME Yes/No */}
                                        <FormGroup className="msme-container mt-4">
                                            <Label className="msme-label">Are you registered under MSME? <span className="required-field">*</span></Label>
                                            <div className="toggle-group mt-2">
                                                <Label className={formData.hasMSME === "yes" ? "toggle-label active" : "toggle-label"}>
                                                    <Input
                                                        type="radio"
                                                        name="hasMSME"
                                                        value="yes"
                                                        checked={formData.hasMSME === "yes"}
                                                        disabled={isReadOnlyMode}
                                                        onChange={(e) =>
                                                            setFormData({ ...formData, hasMSME: e.target.value })
                                                        }
                                                    />
                                                    Yes
                                                </Label>
                                                <Label className={formData.hasMSME === "no" ? "toggle-label active" : "toggle-label"}>
                                                    <Input
                                                        type="radio"
                                                        name="hasMSME"
                                                        value="no"
                                                        checked={formData.hasMSME === "no"}
                                                        disabled={isReadOnlyMode}
                                                        onChange={(e) =>
                                                            setFormData({
                                                                ...formData,
                                                                hasMSME: e.target.value,
                                                                msmeno: "",
                                                                MSMECERTIFICATEIMAGE: null,
                                                            })
                                                        }
                                                    />
                                                    No
                                                </Label>
                                            </div>
                                        </FormGroup>
                                        {formData.hasMSME === "yes" && (
                                            <div className="expandable-section">
                                                <FormGroup>
                                                    <Label for="msmeno">MSME Registration No.</Label>
                                                    <Input
                                                        type="text"
                                                        id="msmeno"
                                                        name="msmeno"
                                                        value={formData.msmeno || ""}
                                                        placeholder={isReadOnlyMode ? "N/A" : "Enter MSME Registration No."}
                                                        onChange={handleInputChange}
                                                        disabled={isReadOnlyMode}
                                                    />
                                                    
                                                    {errors.msmeno && <span className="error-text">{errors.msmeno}</span>}
                                                </FormGroup>
                                                {/* MSME Upload */}
                                                <FormGroup className="form-group">
                                                    <Label for="MSMECERTIFICATEIMAGE">Upload MSME Certificate: <span className="required-field">*</span></Label>
                                                    <Input type="file" name="MSMECERTIFICATEIMAGE" onChange={handleFileChange} disabled={isReadOnlyMode} />
                                                    
                                                    {formData.MSMECERTIFICATEIMAGE?.fileName && (
                                                        <span title={formData.MSMECERTIFICATEIMAGE.fileName} style={{ display: "block", marginTop: "4px", fontSize: "12px", color: "var(--fld-text)" }}>
                                                            {formData.MSMECERTIFICATEIMAGE.fileName.slice(0, 20)}
                                                        </span>
                                                    )}
                                                    {errors.MSMECERTIFICATEIMAGE && (
                                                        <span className="error-text">
                                                            {errors.MSMECERTIFICATEIMAGE}
                                                        </span>
                                                    )}
                                                    {(formData.MSMECERTIFICATEIMAGE?.fileId || formData.MSMECERTIFICATEIMAGE?.file) && (
                                                        <div style={{ marginTop: "8px", display: "flex", gap: "8px", alignItems: "center" }}>
                                                            <Button
                                                                color="primary"
                                                                size="sm"
                                                                className="custom-btn view-btn"
                                                                outline
                                                                onClick={() => {
                                                                    const url = formData.MSMECERTIFICATEIMAGE?.fileId
                                                                        ? `/api/vendor/files/${formData.MSMECERTIFICATEIMAGE.fileId}?mode=view`
                                                                        : URL.createObjectURL(formData.MSMECERTIFICATEIMAGE.file);
                                                                    setPreviewUrl(url);
                                                                    setPreviewTitle("MSME Certificate Preview");
                                                                    setSelectedFile(formData.MSMECERTIFICATEIMAGE);
                                                                    setShowPreview(true);
                                                                }}
                                                            >
                                                                View
                                                            </Button>
                                                            <a
                                                                href={
                                                                    formData.MSMECERTIFICATEIMAGE?.fileId
                                                                        ? `/api/vendor/files/${formData.MSMECERTIFICATEIMAGE.fileId}`
                                                                        : URL.createObjectURL(formData.MSMECERTIFICATEIMAGE.file)
                                                                }
                                                                download={formData.MSMECERTIFICATEIMAGE.fileName}
                                                                className="custom-btn download-btn" 
                                                                style={{ display: "none" }}
                                                            >
                                                                Download
                                                            </a>
                                                        </div>
                                                    )}
                                                </FormGroup>
                                                {/* Type of Enterprise — shown only after MSME certificate is uploaded */}
                                                {(formData.MSMECERTIFICATEIMAGE?.fileId || formData.MSMECERTIFICATEIMAGE?.file) && (
                                                    <FormGroup className="form-group">
                                                        <Label for="enterpriseType">
                                                            Type of Enterprise <span className="required-field">*</span>
                                                        </Label>
                                                        <Input
                                                            type="select"
                                                            id="enterpriseType"
                                                            className="form-input"
                                                            value={formData.enterpriseType}
                                                            onChange={handleInputChange}
                                                            disabled={isReadOnlyMode}
                                                        >
                                                            <option value="">{isReadOnlyMode ? "N/A" : "Select"}</option>
                                                            <option value="Micro">Micro</option>
                                                            <option value="Small">Small</option>
                                                            <option value="Medium">Medium</option>
                                                        </Input>
                                                        {errors.enterpriseType && (
                                                            <span className="error-text">{errors.enterpriseType}</span>
                                                        )}
                                                    </FormGroup>
                                                )}
                                            </div>
                                        )}
                                        <FormGroup className="form-group">
                                            <Label for="beneficiaryName">Beneficiary Name <span className="required-field">*</span></Label>
                                            <div className="input-error-container">
                                                <Input type="text" id="beneficiaryName" className="form-input" value={formData.beneficiaryName} placeholder={isReadOnlyMode ? "N/A" : "Enter Beneficiary Name"} onChange={handleInputChange} disabled={isReadOnlyMode} />
                                                
                                                {errors.beneficiaryName && <span className="error-text">{errors.beneficiaryName}</span>}
                                            </div>
                                        </FormGroup>
                                        <FormGroup className="form-group">
                                            <Label for="revenue">Revenue Previous Year (Annual Turnover) <span className="required-field">*</span></Label>
                                            <div className="input-error-container">
                                                <Input type="text" id="revenue" className="form-input" value={formatIndianNumber(formData.revenue)} placeholder={isReadOnlyMode ? "N/A" : "Enter Revenue"} onChange={handleInputChange} style={{ textAlign: "right" }} disabled={isReadOnlyMode} />
                                                
                                                {errors.revenue && <span className="error-text">{errors.revenue}</span>}
                                            </div>
                                        </FormGroup>
                                        <FormGroup className="form-group">
                                            <Label for="investment">Investment (Plant & Machinery / Equipment) <span className="required-field">*</span></Label>
                                            <div className="input-error-container">
                                                <Input type="text" id="investment" className="form-input" value={formatIndianNumber(formData.investment)} placeholder={isReadOnlyMode ? "N/A" : "Enter Investment"} onChange={handleInputChange} style={{ textAlign: "right" }} disabled={isReadOnlyMode} />
                                                
                                                {errors.investment && <span className="error-text">{errors.investment}</span>}
                                            </div>
                                        </FormGroup>
                                        {/* BACK + SUBMIT BUTTONS */}
                                        <div style={{
                                            gridColumn: "1 / -1",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            marginTop: "32px",
                                            paddingTop: "24px",
                                            borderTop: "1px solid var(--fld-border)"
                                        }}>
                                            <Button
                                                type="button"
                                                className="back-btn"
                                                onClick={() => setActiveTab("details")}
                                            >
                                                ← Back
                                            </Button>

                                            {!isReadOnlyMode ? (
                                                <Button
                                                    type="button"
                                                    className="submit-button"
                                                    onClick={handleSubmit}
                                                    style={{ margin: 0 }}
                                                >
                                                    Submit
                                                </Button>
                                            ) : (
                                                <div style={{
                                                    backgroundColor: "var(--accent-soft)",
                                                    color: "var(--accent)",
                                                    padding: "12px 28px",
                                                    borderRadius: "14px",
                                                    fontWeight: "600",
                                                    fontSize: "15px",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    gap: "8px"
                                                }}>
                                                    ✓ Details Submitted
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </DashboardLayout>
    );
};
export default Vendors;
